import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, EyeIcon, ZapIcon, StethoscopeIcon } from 'lucide-react';
const differentiators = [{
  icon: SparklesIcon,
  title: 'Simple',
  desc: 'Sin complicaciones, sin tecnología obligatoria.'
}, {
  icon: EyeIcon,
  title: 'Claro',
  desc: 'Fácil de leer, incluso con letra grande.'
}, {
  icon: ZapIcon,
  title: 'Rápido',
  desc: 'En segundos puedes verificar qué sigue.'
}, {
  icon: StethoscopeIcon,
  title: 'Útil en consulta',
  desc: 'Llegas con preguntas y datos listos.'
}];
export function DifferentiatorSection() {
  return <section className="bg-navy py-24 px-6 md:px-12 lg:px-24 text-white" data-id="element-36">
      <div className="max-w-7xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-38">
          <h2 className="text-4xl md:text-5xl font-bold text-gold mb-8" data-id="element-39">
            Lo que hace diferente a Checklist Vital
          </h2>
          <p className="text-xl md:text-2xl text-cream/90 leading-relaxed" data-id="element-40">
            Muchas personas intentan usar libretas, papeles sueltos o notas en
            el teléfono. El problema es que se pierde, se desordena o no se
            entiende rápido.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-41">
          {differentiators.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 p-8 rounded-3xl backdrop-blur-sm border border-white/10 text-center flex flex-col items-center" data-id="element-42">
              <div className="bg-gold/20 p-4 rounded-full mb-6" data-id="element-43">
                <item.icon className="w-10 h-10 text-gold" data-id="element-44" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-45">
                {item.title}
              </h3>
              <p className="text-lg text-cream/80 leading-relaxed" data-id="element-46">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}